import axios from "axios";
import React, { useEffect, useState } from "react";
// import { firestore, storage } from '../../firebase';
import { useTranslation } from "react-i18next";
import CarStatusUpdateForm from "./CarStatusUpdateForm";
import { authorizeStyles } from "./CleanerStyles";
import { useToast } from "../../../contexts/ToastContext";

const Cleaner = () => {
    const { t } = useTranslation("cleaner");
    const [step] = useState("cleanerId");
    const [cleanerId, setCleanerId] = useState("");
    const [cleanerData] = useState("");
    const [carPlateNumber, setCarPlateNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [serialNumber] = useState("");
    const [buttonHover, setButtonHover] = useState(false);
    const [responsiveStyles, setResponsiveStyles] = useState(authorizeStyles(window.innerWidth));
    const toast = useToast();

    useEffect(() => {
        const handleResize = () => {
            setResponsiveStyles(authorizeStyles(window.innerWidth));
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleCleanerIdSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        // const cleanerRef = firestore.collection('Cleaners');
        // const snapshot = await cleanerRef.where('cleanerID', '==', cleanerId.toUpperCase()).get();

        // if (!snapshot.empty) {
        //     setStep('carPlateNumber');
        //     const cleanerDoc = snapshot.docs[0];
        //     const cleanerData = cleanerDoc.data();

        //     setCleanerData(cleanerData);
        // } else {
        //     setError('Invalid Cleaner ID. Please try again.');
        // }
        setError("Firebase disabled - Cleaner ID validation not available");
        setLoading(false);
    };

    const handleCarPlateSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        // const carNumberRef = firestore.collection('Cars');
        // const snapshot = await carNumberRef.where('carNumber', '==', carPlateNumber).get();

        // if (!snapshot.empty) {
        //     const carDoc = snapshot.docs[0];
        //     setCarDocumentId(carDoc.id);
        //     setSerialNumber(carDoc.data().serialNumber.toString());
        //     setStep('actions');
        // } else {
        //     setError('Invalid Car Plate Number. Please try again.');
        // }
        setError("Firebase disabled - Car plate validation not available");
        setLoading(false);
    };

    const handleUnlock = async () => {
        const response = await axios.put("https://apicarapp.herokuapp.com/unlockCar", { serialNumber });
        if (response) {
            toast.success({ message: t("unlockSuccess") });
        }
    };

    const handleLock = async () => {
        const response = await axios.put("https://apicarapp.herokuapp.com/lockCar", { serialNumber });
        if (response) {
            toast.success({ message: t("lockSuccess") });
        }
    };

    // const handleCleaningStatus = () => {
    //     if (
    //         window.confirm(
    //             'Are you sure? Confirming this will mark this cleaning status as "Active"',
    //         )
    //     ) {
    //         // firestore.collection('Cars').doc(carDocumentId).update({ cleaningStatus: true });
    //         alert("Success! You have updated the cleaning status as Active!");
    //     } else {
    //         // firestore.collection('Cars').doc(carDocumentId).update({ cleaningStatus: false });
    //         alert(
    //             "Success! You have updated the cleaning status as Deactivated!",
    //         );
    //     }
    // };

    const uploadImage = async (file, section, taskName) => {
        if (!file) return null;

        // console.log("File Type:", file.type);

        // const fileType = file.type || "image/jpeg";
        // const fileRef = storage.ref(`${section}/${taskName}_${Date.now()}`);

        // const metadata = {
        //     contentType: fileType,
        // };

        // try {
        //     await fileRef.put(file, metadata);
        //     return await fileRef.getDownloadURL();
        // } catch (error) {
        //     console.error('Error uploading the image:', error);
        //     return null;
        // }

        // Mock upload - return a placeholder URL
        return `https://placeholder.com/${section}/${taskName}_${Date.now()}`;
    };

    function dataURLtoFile(dataUrl, filename) {
        const arr = dataUrl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);
        for (let i = n - 1; i >= 0; i -= 1) {
            u8arr[i] = bstr.charCodeAt(i);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const handleSubmit = async (values) => {
        setLoading(true);
        const updatedValues = { ...values };

        // Process all tasks concurrently using Promise.all instead of a for-of loop
        await Promise.all(
            Object.entries(updatedValues.inspection).map(async ([taskName, task]) => {
                if (task.images && task.images.length > 0) {
                    const uploadedImages = await Promise.all(
                        task.images.map(async (imageDataUrl, index) => {
                            try {
                                const imageFile = dataURLtoFile(imageDataUrl, `image-${taskName}-${index}.png`);
                                return await uploadImage(imageFile, "inspection", `${taskName}-${index}`);
                            } catch (_error) {
                                return null;
                            }
                        }),
                    );
                    updatedValues.inspection[taskName].images = uploadedImages.filter((url) => url !== null);
                }
            }),
        );

        const data = {
            values: updatedValues,
            cleanerData,
            carPlateNumber,
            date: new Date(),
        };

        const api = axios.create({
            baseURL: "http://localhost:3011",
            headers: {
                "Content-Type": "application/json",
            },
        });

        try {
            const res = await api.post("/cleanerStatus/createCleanerStatus", data);
            // console.log("Form submitted with values:", data);
            if (res?.data?.message) {
                toast.success({ message: t("statusCreated") });
                window.location.reload();
            }
        } catch (_err) {
            // console.error(err);
            toast.error({
                message: t("error"),
                description: t("submitFailed"),
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={responsiveStyles.container}>
            {(step === "cleanerId" || step === "carPlateNumber") && (
                <div style={responsiveStyles.form}>
                    <h1 style={responsiveStyles.title}>Car Status Update Form</h1>
                    {error && <div style={responsiveStyles.error}>{error}</div>}

                    {step === "cleanerId" && (
                        <form onSubmit={handleCleanerIdSubmit}>
                            <div style={{ marginBottom: "1rem" }}>
                                <label htmlFor="cleanerId" style={responsiveStyles.label}>
                                    Please enter your cleaner ID to start the process
                                </label>
                                <input
                                    type="text"
                                    id="cleanerId"
                                    value={cleanerId}
                                    onChange={(e) => setCleanerId(e.target.value)}
                                    placeholder="ABC123XY"
                                    required
                                    style={responsiveStyles.input}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    ...responsiveStyles.button,
                                    ...(loading ? responsiveStyles.buttonDisabled : {}),
                                    ...(buttonHover && !loading ? responsiveStyles.buttonHover : {}),
                                }}
                                onMouseEnter={() => setButtonHover(true)}
                                onMouseLeave={() => setButtonHover(false)}>
                                {loading ? "Authorizing..." : "Authorize"}
                            </button>
                        </form>
                    )}

                    {step === "carPlateNumber" && (
                        <form onSubmit={handleCarPlateSubmit}>
                            <div style={{ marginBottom: "1rem" }}>
                                <label htmlFor="carPlateNumber" style={responsiveStyles.label}>
                                    Please enter your car plate number:
                                </label>
                                <input
                                    type="text"
                                    id="carPlateNumber"
                                    value={carPlateNumber}
                                    onChange={(e) => setCarPlateNumber(e.target.value)}
                                    placeholder="236152"
                                    required
                                    style={responsiveStyles.input}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    ...responsiveStyles.button,
                                    ...(loading ? responsiveStyles.buttonDisabled : {}),
                                    ...(buttonHover && !loading ? responsiveStyles.buttonHover : {}),
                                }}
                                onMouseEnter={() => setButtonHover(true)}
                                onMouseLeave={() => setButtonHover(false)}>
                                {loading ? "Authorizing..." : "Authorize"}
                            </button>
                        </form>
                    )}
                </div>
            )}

            {step === "actions" && (
                <CarStatusUpdateForm
                    onUnlock={handleUnlock}
                    onLock={handleLock}
                    onSubmit={handleSubmit}
                    loading={loading}
                />
            )}
        </div>
    );
};

export default Cleaner;
